<template>
  <section>
    <v-dialog
      v-model="newGeneralTicketDialog"
      width="800px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h2>New General Support Ticket</h2>
          <div class="btn-container">
            <v-button
              size="small"
              @click="handleCancel">Cancel</v-button>
            <v-button
              size="small"
              type="primary"
              @click="handlerCreate">Create</v-button>
          </div>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-content flex">
            <div class="left">
              <div
                v-if="isCreate"
                class="form-item pd-b-30">
                <el-form-item
                  ref="merchant_platform"
                  :rules="rules.select"
                  prop="merchant_platform">
                  <select-quote-type v-model.number="formData.merchant_platform"></select-quote-type>
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Assignee</span>-->
                <el-form-item
                  prop="assignee_id"
                  label="Assignee">
                  <v-select
                    v-model="formData.assignee_id"
                    :disabled="!!formData.assignee_id"
                    :list="globalOptions.assignee" />
                </el-form-item>
              </div>
              <div
                v-if="isCreate"
                class="form-item">
                <span>{{ isFina?'Referrer':'Customer' }}</span>

                <el-form-item
                  prop="customer_id"
                  :rules="rules.select"
                >
                  <v-button
                    :icon="isFina?'user-tie':'user-circle'"
                    gray
                    @click="handlerSelectAccount">{{isFina?btn_refer_text:btn_text}}</v-button>
                </el-form-item>
              </div>
              <div
                v-if="!isFina&&!isCreate"
                class="form-item">
                <!--              <span>Customer</span>-->
                <el-form-item
                  prop="customer_id"
                  label="Customer">
                  <el-select
                    v-if="!!form.customer_id"
                    v-model="customerName"
                    disabled
                    size="small"
                  >
                    <el-option
                      :label="customerName"
                      :value="customerName"></el-option>
                  </el-select>
                  <v-select
                    v-else
                    v-model="formData.customer_id"
                    :clearable="true"
                    remote
                    nameGroup
                    :remoteMethod="remoteMethodUser"
                    labelKey="isrd_nm"
                    :list="customerOptionsUser"
                    @change="changeCustomer" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Policy</span>
                <!-- <v-autocomplete
                  v-model="formData.policy_no"
                  :disabled="!!form.policy_no"
                  labelKey="pcy_no"
                  valueKey="pcy_no"
                  :list="customerPolicyList"
                  @select="handlerSelectPolicy"/> -->
                <v-autocomplete
                  v-model="formData.pcy_id"
                  :disabled="!!form.pcy_id"
                  labelKey="pcy_id"
                  valueKey="pcy_id"
                  :list="customerPolicyList"
                  @select="handlerSelectPolicy"/>
              </div>
              <div class="form-item">
                <span>Quote</span>
                <v-autocomplete
                  v-model="formData.quote_no"
                  :disabled="!!form.quote_no"
                  labelKey="quotation_number"
                  valueKey="quotation_number"
                  :list="customerQuoteList" />
              </div>
            </div>
            <div class="right">
              <div class="form-item">
                <!--              <span>Title</span>-->
                <el-form-item
                  prop="subject"
                  label="Title">
                  <v-input v-model="formData.subject" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Message</span>
                <v-input
                  v-model="formData.message"
                  type="textarea"
                  :rows="9" />
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </v-dialog>
    <attach-customer
      ref="attachCustomer"
      :customer-type="formData.merchant_platform"
      is-all-type
      @handlerSelectCustomer="handlerSelectCustomer"></attach-customer>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {createGeneralTicket, getCustomerPolicy} from '@/api/ticket'
import {mapActions, mapState} from 'vuex'
import SelectQuoteType from '@/views/components/select-quote-type'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import MixinFina from '@/mixins/fina'

export default {
  name: 'NewGeneralTicket',
  components:{
    SelectQuoteType,
    attachCustomer,
  },
  mixins: [MixinOptions, MixinRules,MixinFina],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: [Object,Array],
      default: () => ({})
    },
    isCreate: {
      type: [Boolean],
      default: false
    },
  },
  data() {
    return {
      newGeneralTicketDialog:false,
      customerPolicyList: [],
      customerQuoteList: [],
      formData: {
        assignee_id: '',
        customer_id: '',
        // policy_no: '',
        pcy_id: '',
        quote_no: '',
        subject: '',
        message: '',
        merchant_platform:1,
      }
    }
  },
  computed:{
    ...mapState('common', ['customerOptionsPhone','customerOptionsUser','customerOptionsEmail']),
    ...mapState('account', ['selectReferCustomerData','selectCustomerData','customerId','referCustomerId']),
    customerName(){
      let {isrd_nm} = this.customer||{}
      return isrd_nm ? isrd_nm : ' '
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      if(this.isCreate){
        return this.formData.merchant_platform ==2
      }
      return merchant_platform == 2
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = Object.assign(this.formData, val)
      }
    },
    isCreate:{
      immediate:true,
      handler(val){
        if(!val){
          let {merchant_platform} = this.form||{}
          this.formData.merchant_platform = merchant_platform
        }
      }
    },
    // 'formData.customer_id': {
    //   // immediate: true,
    //   handler(val) {
    //     if(val) {
    //       this.handlerChangeCustomer(val)
    //     }
    //   }
    // }
  },
  created() {
    let name = localStorage.getItem('cs_name')
    let arr = this.globalOptions.assignee||[]
    arr.some(item=>{
      if(item.name==name)
        this.formData.assignee_id = item.id
    })
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    handleCancel(){
      this.handleClear()
      this.newGeneralTicketDialog =false
    },
    handleClear(){
      this.setCustomerId(null)
      this.setReferCustomerId(null)
      this.setSelectReferCustomerData(null)
      this.setSelectCustomerData(null)
    },
    handlerSelectCustomer(){
      let {id} = this.selectReferCustomerData||{}
      this.formData.customer_id = this.isFina?id:this.customerId
      this.handlerChangeCustomer(this.isFina?id:this.customerId)
    },
    handlerSelectAccount(){
      this.$refs.attachCustomer.showAttachCustomer()
    },
    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    changeDialog() {
      if(this.formData.customer_id && this.customerPolicyList.length < 1) {
        this.handlerChangeCustomer(this.formData.customer_id)
      }
      this.newGeneralTicketDialog = !this.newGeneralTicketDialog
    },
    changeCustomer(id) {
      this.handlerChangeCustomer(id)
    },
    handlerChangeCustomer(id) {
      if(id) {
        this.network().getCustomerPolicy(id)
      }
    },
    handlerCreate() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.network().createGeneralTicket()
          this.setCustomerOptionNUll()
        }
      })

    },
    handlerSelectPolicy(item) {
      this.formData.quote_no = item.quotation_number
    },
    network() {
      return {
        createGeneralTicket: async () => {
          let params ={}
          if(this.isFina){
            if(this.isCreate)
              params.referrer_id = this.referCustomerId
            delete this.formData.customer_id
          }
          const { data } = await createGeneralTicket({...this.formData,...params})
          this.changeDialog()
          this.handleClear()
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        },
        getCustomerPolicy: async id => {
          let params ={}
          params.customer_id = id
          if(this.isFina&&this.isCreate){
            params.referrer_id = this.referCustomerId
            delete params.customer_id
          }
          const { data } = await getCustomerPolicy({
            ...params,
            merchant_platform:this.isFina?2:1
          })
          this.customerPolicyList = data.policy
          this.customerQuoteList = data.quote
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
